























import { defineComponent, computed } from '@vue/composition-api';
import TtamCreativeProductAnchorToggle from './product-anchor-toggle/index.vue';
import TtamCreativeProductCategory from './product-category/index.vue';

const name = 'ttam-creative-product-anchor-compose';
export default defineComponent({
  name,
  components: { TtamCreativeProductAnchorToggle, TtamCreativeProductCategory },
  props: {
    roi2CreativeType: {
      type: Number,
      default: 0,
    },
    productCategory: {
      type: String,
      default: '',
    },
    showProductCategory: {
      type: Boolean,
      default: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    disabledText: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: '',
    },
    description: {
      type: String,
      default: '',
    },
    roi2CountryHint: {
      type: String,
      default: '',
    },
    hoverImg: {
      type: String,
      default: '',
    },
  },
  setup(props, { emit }) {
    const _roi2CreativeType = computed(() => Boolean(props.roi2CreativeType));

    const onRoi2CreativeTypeChange = val => {
      emit('changeRoi2CreativeType', val);
    };

    const onProductCategoryChange = val => {
      emit('changeProductCategory', val);
    };

    return {
      _roi2CreativeType,

      onProductCategoryChange,
      onRoi2CreativeTypeChange,
    };
  },
});
